var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTgStarGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21512 3.804L5.46565 1.31944C5.61024 1.03298 5.96 0.918008 6.24528 1.06221C6.35666 1.11872 6.44654 1.21031 6.5032 1.32333L7.68535 3.72021C7.78109 3.91702 7.97063 4.04953 8.18752 4.07487L10.6593 4.37106C10.9954 4.41199 11.2357 4.71793 11.1966 5.05505C11.179 5.19341 11.1165 5.32202 11.0169 5.41945L9.06094 7.3428C8.98082 7.42074 8.9437 7.52987 8.95738 7.64094L9.28369 10.2366C9.33058 10.6088 9.0668 10.9479 8.69555 10.9946C8.55486 11.0122 8.41418 10.9868 8.28912 10.9186L6.22379 9.79228C6.07333 9.71044 5.89357 9.70849 5.74311 9.78644L3.60157 10.8816C3.30066 11.0355 2.93332 10.9147 2.77895 10.6127C2.72034 10.4997 2.7008 10.373 2.71838 10.2483L2.88838 9.05569C2.9724 8.47303 3.33388 7.96637 3.85754 7.69941L6.23356 6.48928C6.29608 6.4581 6.32148 6.38015 6.29022 6.31584C6.26482 6.26713 6.21206 6.2379 6.15735 6.24569L3.24986 6.66271C2.80631 6.72507 2.3569 6.60035 2.00714 6.31584L1.03993 5.52858C0.764421 5.30448 0.71948 4.89526 0.944185 4.61855C1.0497 4.48993 1.20015 4.40614 1.36429 4.38471L3.84582 4.06707C4.00409 4.04563 4.14282 3.9482 4.21512 3.804Z",
    fill: "url(#paint0_linear_481_4045)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_4045",
    x1: 4.47137,
    y1: -0.0714288,
    x2: 12.4742,
    y2: 7.18535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD21A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E47B03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTgStarGold);
export default __webpack_public_path__ + "static/media/icon-tg-star-gold.17c6ae355d8c95cd97692085e3ff47c3.svg";
export { ForwardRef as ReactComponent };